import * as React from 'react';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import * as Data from '../../Data';
import * as DatiFide from '../../DatiFide';
import { NavLink } from 'react-router-dom';
import { Bottone, Paginatore, BaseComponent, Tipo, Trad, ChiamaAPI, CampoData } from '../../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IFattureDatiEconomiciListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineTipi_FattureDatiEconomici;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class FattureDatiEconomiciLista extends BaseComponent<Glob.IRouteGlobaleProps, IFattureDatiEconomiciListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        //if ((this.props.match.params as any).ID_AnagFornitore != undefined && (this.props.match.params as any).ID_AnagFornitore != null && (this.props.match.params as any).ID_AnagFornitore != "") {
        //    this.ParametriFissi["ID_AnagFornitore"] = (this.props.match.params as any).ID_AnagFornitore;
        //}
        this.state = {
            Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {}
        };

        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
        this.AttivaTabella();
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });

        this.OnErrore = this.OnErrore.bind(this);
    }


    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineTipi_FattureDatiEconomici, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={6} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr data-row="0" key={dato.ID_FatturaDatiEconomici}>
                        <td className="TextLeft">
                            <NavLink className="arrow" to={"/Contabilita/FattureDatiEconomici/" + dato.ID_FatturaDatiEconomici}>
                                {dato.ID_FatturaDatiEconomici}
                            </NavLink>
                        </td>
                        <td data-field="Identificativo" className="TextLeft">{dato.Identificativo}</td>
                        <td data-field="DataRiferimento" className="TextCenter">{Data.DataValoreTrad(dato.DataRiferimentoDocumento)}</td>
                        <td data-field="DataUpload" className="TextCenter">{Data.DataValoreTrad(dato.Creato)}</td>
                        <td className="TextCenter">
                            <NavLink className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" to={"/Contabilita/FattureDatiEconomici/" + dato.ID_FatturaDatiEconomici}>
                                <i className="la la-edit"></i>
                            </NavLink>
                        </td>
                    </tr>
                )}
            </tbody >;
        }
        //<div className="divtabella"><ChiamaAPI URL="/api/ControlloLimiti" /></div>
    }

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [4], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_FatturaDatiEconomici", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Identificativo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("DataRiferimentoDocumento", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("Creato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        //this.AttivaTabella();
        return <div>
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-money-check-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("FattureDatiEconomici")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                <NavLink to="/Contabilita/FattureDatiEconomici/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">

                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("ID")}</label>
                            <div className={Glob.DimensioneCSS(3)}>
                                <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_FatturaDatiEconomici"] || ""} name="ParametriUtente[ID_FatturaDatiEconomici]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                            </div>
                            <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("Identificativo")}</label>
                            <div className={Glob.DimensioneCSS(3)}>
                                <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["Identificativo"] || ""} name="ParametriUtente[Identificativo]" className="form-control kt-input" placeholder={Trad.Trad("Identificativo")} />
                            </div>
                            <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("DataRiferimento")}</label>
                            <div className={Glob.DimensioneCSS(3)}>
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={false} Name="ParametriUtente[DataRiferimentoDocumento]" Id="ParametriUtente[DataRiferimentoDocumento]" Valore={this.state.ParametriUtente["DataRiferimentoDocumento"] || ""} OnChange={this.OnChange} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("Creato")}</label>
                            <div className={Glob.DimensioneCSS(3)}>
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={false} Name="ParametriUtente[Creato]" Id="ParametriUtente[Creato]" Valore={this.state.ParametriUtente["Creato"] || ""} OnChange={this.OnChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                        <thead>
                            <tr className="sfondoTab">
                                <th data-field="ID_FatturaDatiEconomici" className="TextLeft">{Trad.Trad("ID")}</th>
                                <th data-field="Identificativo" className="TextLeft">{Trad.Trad("Identificativo")}</th>
                                <th data-field="DataRiferimentoDocumento" className="TextCenter">{Trad.Trad("DataRiferimentoDocumento")}</th>
                                <th data-field="DataUpload" className="TextCenter">{Trad.Trad("DataUpload")}</th>
                                <th data-field="DataUpload" className="TextCenter"></th>
                            </tr>
                        </thead>
                        <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/FatturaDatiEconomici/ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                    </table>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/Contabilita/FattureDatiEconomiciLista.tsx